
import { defineComponent } from 'vue'
import CardTopRightButton from '@/components/CardTopRightButton.vue'

export default defineComponent({
  components: { CardTopRightButton },
  methods: {
    onClick() {
      window.open('/assets/Ubiant - Contrat de garantie de service et maintenance - V 07-09-2022.pdf', '_blank')
    }
  }
})
